/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Portal, useDisclosure } from "@chakra-ui/react";
import Footer from "components/footer/FooterAdmin.js";
import Navbar from "components/navbar/NavbarAdmin.js";
import IconSidebar from "components/sidebar/IconSidebar";
import Sidebar from "components/sidebar/Sidebar.js";
import { SidebarContext } from "contexts/SidebarContext";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import useRoutes from "routes";
import NotFound from "views/auth/404/404_error";

export default function Dashboard(props) {
  const { ...rest } = props;
  const routes = useRoutes();
  const navigate = useNavigate();

  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [collapseSidebar, setCollapseSidebar] = useState(false);
  const [sidebarActive, setSidebarActive] = useState(true);
  const { isAuth, currUser } = useSelector((state) => state.auth);
  const auth = currUser?.auth;

  const moduleAccess = (module) => auth?.some((a) => a.module === module);

  const roleAccess = (route) => {
    const roleObj = auth?.find((item) => item?.module === route?.module);
    return roleObj ? route?.access.includes(roleObj?.access) : false;
  };

  const getRoute = () => window.location.pathname !== "/admin/full-screen-maps";

  const handleSidebar = () => {
    setSidebarActive(!sidebarActive);
    setCollapseSidebar(!collapseSidebar);
  };

  const getActiveRoute = (routesList) => {
    for (let route of routesList) {
      if (window.location.pathname.includes(route.path)) return route.name;
      if (route.subRoutes) {
        const subActive = getActiveRoute(route.subRoutes);
        if (subActive) return subActive;
      }
    }
    if (isAuth && window.location.pathname === "/") {
      navigate("/dashboard");
    }
    if (!isAuth) {
      navigate("/sign-in");
    }
    return "Default Brand Text";
  };

  const getActiveNavbar = (routesList) => {
    for (let route of routesList) {
      if (
        window.location.href.includes(route.layout + route.path) &&
        route.secondary
      )
        return true;
      if (route.subRoutes) {
        const subActive = getActiveNavbar(route.subRoutes);
        if (subActive) return true;
      }
    }
    return false;
  };

  const getActiveNavbarText = (routesList) => {
    for (let route of routesList) {
      if (
        window.location.href.includes(route.layout + route.path) &&
        route.messageNavbar
      )
        return route.messageNavbar;
      if (route.subRoutes) {
        const subText = getActiveNavbarText(route.subRoutes);
        if (subText) return subText;
      }
    }
    return false;
  };

  const renderRoutes = (routesList) => {
    return routesList.flatMap((route, key) => {
      if (route.subRoutes && route.subRoutes.length > 0) {
        return renderRoutes(route.subRoutes);
      }
  
      if (
        currUser &&
        route.module !== "Log Out" &&
        moduleAccess(route.module) &&
        roleAccess(route)
      ) {
        return (
          route.layout === "/" && (
            <Route path={route.path} element={route.component} key={key} />
          )
        );
      }
  
      if (
        route.name === "All Category" ||
        route.name === "Vendor Details" ||
        route.name === "Project Details"
      ) {
        return <Route path={route.path} element={route.component} key={key} />;
      }
  
      return [];
    });
  };
  const { onOpen } = useDisclosure();

  document.documentElement.dir = "ltr";

  return (
    <Box>
      <SidebarContext.Provider value={{ toggleSidebar, setToggleSidebar }}>
        {!collapseSidebar ? (
          <Sidebar
            routes={routes}
            display="none"
            {...rest}
            collapse={collapseSidebar}
            handleSidebar={handleSidebar}
          />
        ) : (
          <IconSidebar
            routes={routes}
            display="none"
            {...rest}
            handleSidebar={handleSidebar}
          />
        )}

        <Box
          float="right"
          minHeight="100vh"
          height="100%"
          position="relative"
          bg="white"
          w={{ base: "100%", xl: `calc(100% - ${collapseSidebar ? "35px" : "200px"})` }}
          maxWidth={{ base: "100%", xl: `calc(100% - ${collapseSidebar ? "35px" : "200px"})` }}
          transition="all 0.3s ease-in-out"
        >
          <Portal>
            <Navbar
              onOpen={onOpen}
              logoText={"Embrill"}
              brandText={getActiveRoute(routes)}
              secondary={getActiveNavbar(routes)}
              message={getActiveNavbarText(routes)}
              fixed={fixed}
              collapseSidebar={collapseSidebar}
              {...rest}
            />
          </Portal>

          {getRoute() && (
            <Box mx="auto" pr={1} pt="50px" minH="100vh">
              <Routes>
                {renderRoutes(routes)}
                <Route path="/*" element={<NotFound />} />
              </Routes>
            </Box>
          )}

          <Footer />
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
